import { AddToProductEmptyMid } from './AddToProductEmptyMid'
import { AddToProductContentMode } from './AddToProductContentMode'
import { AddToProductMediaMode } from './AddToProductMediaMode'
import type { ChannelReorderPlans } from './media/channelReorderPlan'
import type { AddToProductImage, AddToProductPayload, AddToProductTarget } from './types'
import type { ProductSearchMatch } from '@/lib/api/products-search'

interface AddToProductMidProps {
  selected: ProductSearchMatch | null
  tab: 'content' | 'media'
  payload: AddToProductPayload
  pendingByChannelSlot?: Map<string, Map<number, AddToProductImage>>
  pendingByAiRefSlot?: Map<number, AddToProductImage>
  reorderPlans?: ChannelReorderPlans
  onDelete?: (target: AddToProductTarget) => void
}

/**
 * Mid-panel router: empty-state when no product is selected, otherwise the
 * content mode (texts present + content tab) or the Variant-A media mode.
 * Pending drop state is threaded through so the media slot grids can render
 * unsaved drops with an amber indicator.
 */
export function AddToProductMid({
  selected,
  tab,
  payload,
  pendingByChannelSlot,
  pendingByAiRefSlot,
  reorderPlans,
  onDelete,
}: AddToProductMidProps) {
  if (!selected) return <AddToProductEmptyMid />
  if (tab === 'content') {
    return (
      <AddToProductContentMode
        productId={selected.id}
        workspaceIntegrationId={selected.workspace_integration_id}
        texts={payload.texts ?? []}
        onDirtyChange={undefined}
      />
    )
  }
  return (
    <AddToProductMediaMode
      productId={selected.id}
      pendingByChannelSlot={pendingByChannelSlot}
      pendingByAiRefSlot={pendingByAiRefSlot}
      reorderPlans={reorderPlans}
      onDelete={onDelete}
    />
  )
}
